import axios from 'axios';
import * as actionTypes from './actionTypes';
import apiCall from '../app/apiCall.js';
import { LANGUAGE } from './../constants';
let commonLabels;

if (sessionStorage.getItem(LANGUAGE.LANG_KEY) === LANGUAGE.FRENCH) {
  commonLabels = require('./../../labels/labels.french.json').commonLabels;
} else {
  commonLabels = require('./../../labels/labels.json').commonLabels;
}
export function getLanguage(staffId) {
  return () => {
    const languageUrl = `profiles/${staffId}`;
    apiCall(languageUrl, 'get').then(response => {
      sessionStorage.setItem(
        LANGUAGE.LANG_KEY,
        response.data.language && response.data.language.code
          ? response.data.language.code
          : null
      );
      window.location.reload();
    });
  };
}

export const fetchHomeRequest = () => ({
  type: actionTypes.FETCH_HOME_REQUEST
});
export const fetchHomeFailure = message => ({
  type: actionTypes.FETCH_HOME_FAILURE,
  message
});
export const fetchHomeSuccess = home => ({
  type: actionTypes.FETCH_HOME_SUCCESS,
  home
});

export const fetchHome = staffId => {
  return dispatch => {
    dispatch(fetchHomeRequest());
    let user;
    let messages = [];

    fetch(`api/employees/${staffId}`)
      .then(response => response.json())
      .then(json => {
        user = json;
        fetch(`api/preferences/bid-sessions`)
          .then(res => res.json())
          .then(json => {
            const openBids = json;

            return dispatch(fetchHomeSuccess({ user, messages, openBids }));
          });
      });

    return staffId;
  };
};
